import { config, environment } from '@/config'
import { merge } from 'lodash'
import Vue from 'vue'
import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import http from 'utils/http'

Pusher.logToConsole = !environment('production')

export default {
  connect () {
    const options = merge({
      broadcaster: 'pusher',
      key: config.PUSHER_KEY,
      // Authorize channel subscriptions through the shared axios instance so
      // every auth request carries the current JWT. A static auth header goes
      // stale once the token rotates and gets blacklisted.
      authorizer: (channel) => ({
        authorize: (socketId, callback) => {
          http.post(`${process.env.API_DOMAIN}/broadcasting/auth`, {
            socket_id: socketId,
            channel_name: channel.name
          }).then(response => {
            callback(false, response.data)
          }).catch(error => {
            callback(true, error)
          })
        }
      }),
      namespace: 'Arrow.Events',
      cluster: 'ap1'
    }, config.PUSHER_CONFIG)

    Vue.prototype.$echo = new Echo(options)
  }
}

window.onbeforeunload = () => {
  if (Vue.prototype.$echo) {
    // if user is downloading report, don't disconnect it
    if (window.location.href.indexOf('auth') !== -1) {
      Vue.prototype.$echo.disconnect()
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/pusher.js